export const API_URL =
   process.env.API_URL || "https://api.dev.corrections.grasp-innovations.com"

export enum Endpoints {
   LOGIN = "/v1/authentication/login/",
   LOGIN_VERIFY = "/v1/authentication/login/verify/",
   ENTRA_LOGIN = "/v1/authentication/entra/login/",
   ENTRA_CALLBACK = "/v1/authentication/entra/callback/",
   LOGOUT = "/v1/authentication/logout/",
   VERIFY = "/v1/authentication/tokens/",
   ADD_USER = "/v1/authentication/users/",
   ACTIVATE_USER = "/v1/authentication/users/activation/",
   PASSWORD_RESET = "/v1/authentication/password/reset/",
   PASSWORD_RESET_CONFIRM = "/v1/authentication/password/reset/confirm/",
   USER = "/v1/user/",
   USER_TOKEN = "/v1/user/token/",
   USERS = "/v1/users/",
   CUSTOMERS = "/v1/customers/",
   FACILITIES = "/v1/facilities/",
   ALERTS = "/v1/alerts/",
   LEVELS = "/v1/levels/",
   LEVELS_CONFIGURATIONS = "/v1/levels/configurations/",
   LEVELS_EXPORT = "/v1/levels/export/",
   INMATES = "/v1/inmates/",
   SENSORS = "/v1/sensors/",
   WEARABLES_CHARGING_STATUS = "/v1/sensors/wearables/charging-status/",
}
